/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementUnauthorizedResponse,
  BranchStockOverviewResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get cumulative stock details across all accounting location with association details as well.
 */
export const getStockBranchOverviewDetails = (signal?: AbortSignal) => {
  return customInstance<BranchStockOverviewResponseResponse>({
    url: `/bm-stock-management-service/v1/stock-branch-overview`,
    method: 'get',
    signal,
  });
};

export const getGetStockBranchOverviewDetailsQueryKey = () => {
  return [`/bm-stock-management-service/v1/stock-branch-overview`] as const;
};

export const getGetStockBranchOverviewDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockBranchOverviewDetails>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStockBranchOverviewDetails>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockBranchOverviewDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockBranchOverviewDetails>>> = ({
    signal,
  }) => getStockBranchOverviewDetails(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockBranchOverviewDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockBranchOverviewDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockBranchOverviewDetails>>
>;
export type GetStockBranchOverviewDetailsQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary Get cumulative stock details across all accounting location with association details as well.
 */
export const useGetStockBranchOverviewDetails = <
  TData = Awaited<ReturnType<typeof getStockBranchOverviewDetails>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStockBranchOverviewDetails>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockBranchOverviewDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
